import {
  SET_TRA_GOP_EDIT,
  SET_CONFIG_TM_TRA_GOP,
  SHOW_FORM_TRA_GOP,
  GET_CONFIG_SYS_TMTG,
  POST_TRA_GOP,
  POST_TRA_GOP_SUCCESS,
  POST_TRA_GOP_FAILURE,
  CHECK_EDIT_TRA_GOP,
  CHECK_EDIT_CUSTOMER_TG,
  SET_ENABLE_EDIT_TRA_GOP,
  SET_ENABLE_EDIT_CUSTOMER_TG,
  SET_TAI_SAN_TG,
  GET_TAI_SAN_THEO_CHO_VAY_TMTG,
} from "actions/ThemMoiTraGop/actionTypes";
import { convertToNumber } from "utils/numberExtension";

const initialState = {
  choVayEdit: {
    NgayVay: new Date(),
    CustomerId: 0,
    IsEditChoVay: true,
    IsEditCustomer: true,
    IsDuNoGiamDan: false,
    ValueLai: 0,
    TienThuHangKy: 0,
    StatusPaidHo: 1,
    TypeDuNo: 1,
  },
  ConfigTMTG: {},
  isShowFormTraGop: false,
  postTraGopLoading: false,
  postTraGopReturn: false,
  TaiSanTraGop: {},
};
const setTaiSanTraGop = (state, action) => ({
  ...state,
  TaiSanTraGop: action.payload,
});
const setChoVayEdit = (state, action) => {
  let { ConfigTMTG } = state;
  let { _laiTraGop } = ConfigTMTG;
  let choVayEdit = action.payload;
  let { StatusPaidHo, Sotienvay, ValueLai, BocTrongVong, CountTypePaid } =
    choVayEdit;
  let tienVay = convertToNumber(Sotienvay);
  let tienLai = convertToNumber(ValueLai);
  choVayEdit.TienCatTruoc = tienVay - tienLai;
  let bocTrongVong = convertToNumber(BocTrongVong);
  let countTypePaid = convertToNumber(CountTypePaid);

  if (StatusPaidHo === 1) {
    choVayEdit.TienThuHangKy = (tienVay * countTypePaid) / bocTrongVong;
  } else {
    choVayEdit.TienThuHangKy =
      ((tienVay + tienLai) * countTypePaid) / bocTrongVong;
    if (_laiTraGop === 2) {
      choVayEdit.TitleValueLai =
        "VD: cho vay 10tr, tổng thu 1 kỳ 3tr thì điền 3tr";
      choVayEdit.TienThuHangKy = tienLai;
    } else if (_laiTraGop === 1) {
      choVayEdit.TitleValueLai = "VD: cho vay 10tr, lãi 1 kỳ 3tr thì điền 3tr";
      choVayEdit.TienThuHangKy =
        (tienVay * countTypePaid) / bocTrongVong + tienLai;
    } else {
      choVayEdit.TitleValueLai = "VD: cho vay 10tr, lãi 3tr thì điền 3tr";
    }
  }
  return {
    ...state,
    choVayEdit: action.payload,
  };
};

const setConfig = (state, action) => {
  let config = action.payload;
  let choVayEdit = { ...state.choVayEdit };
  console.log("[TraGop IsDuNoGiamDan] setConfig before", {
    ChoVayId: choVayEdit.ChoVayId,
    Code: choVayEdit.Code,
    IsDuNoGiamDan: choVayEdit.IsDuNoGiamDan,
    StatusPaidHo: choVayEdit.StatusPaidHo,
    TypeDuNo: choVayEdit.TypeDuNo,
    config,
  });
  let {
    _laiTraGop,
    _kyGopTraGop,
    _khoangThoiGianTraGop,
    _beforeAfterTraGop,
    _duNoGiamDanTraGop,
    _traThieuTraDu,
  } = config;

  if (!choVayEdit.ChoVayId) {
    choVayEdit.TypePaid = parseInt(_kyGopTraGop) === 1 ? 1 : 2;
    choVayEdit.CountTypePaid = parseInt(_khoangThoiGianTraGop)
      ? _khoangThoiGianTraGop
      : "";

    choVayEdit.BeforeAfter = _beforeAfterTraGop === 0 ? 1 : 2;

    choVayEdit.IsDuNoGiamDan = false;
    choVayEdit.StatusPaidHo = _traThieuTraDu === 1 ? 1 : 2;
  }
  choVayEdit.TienCatTruoc = "";

  choVayEdit.LaiTraGop = _laiTraGop;
  if (choVayEdit.ChoVayId) {
    let { StatusPaidHo, Sotienvay, ValueLai, BocTrongVong, CountTypePaid } =
      choVayEdit;
    let bocTrongVong = convertToNumber(BocTrongVong);
    let countTypePaid = convertToNumber(CountTypePaid);
    let tienVay = convertToNumber(Sotienvay + "");
    choVayEdit.IsDuNoGiamDan = StatusPaidHo === 3;
    if (StatusPaidHo === 1) {
      let tienLai = Math.round(choVayEdit.ValueLai * choVayEdit.CountTypePaid);
      choVayEdit.ValueLai = tienVay - tienLai;
      choVayEdit.TienCatTruoc = tienVay - choVayEdit.ValueLai;
      choVayEdit.TienThuHangKy = (tienVay * countTypePaid) / bocTrongVong;
    } else {
      if (_laiTraGop === 2) {
        choVayEdit.TitleValueLai =
          "VD: cho vay 10tr, tổng thu 1 kỳ 3tr thì điền 3tr";
        let lai = choVayEdit.ValueLai * CountTypePaid;
        // choVayEdit.ValueLai = choVayEdit.ValueLai * CountTypePaid;
        choVayEdit.ValueLai = Math.round(
          choVayEdit.ValueLai * CountTypePaid + choVayEdit.ValueGoc,
        );

        let tienLai = convertToNumber(Math.round(lai + choVayEdit.ValueGoc));

        choVayEdit.TienThuHangKy = tienLai;
        console.log("choVayEdit.TienThuHangKy3", choVayEdit.TienThuHangKy);
      } else if (_laiTraGop === 1) {
        choVayEdit.TitleValueLai =
          "VD: cho vay 10tr, lãi 1 kỳ 3tr thì điền 3tr";
        choVayEdit.ValueLai = Math.round(
          choVayEdit.ValueLai * choVayEdit.CountTypePaid,
        );
        let tienLai = Math.round(convertToNumber(choVayEdit.ValueLai + ""));
        choVayEdit.TienThuHangKy =
          (tienVay * countTypePaid) / bocTrongVong + tienLai;

        console.log("choVayEdit.TienThuHangKy2", choVayEdit.TienThuHangKy);
      } else {
        choVayEdit.TitleValueLai = "VD: cho vay 10tr, lãi 3tr thì điền 3tr";
        choVayEdit.ValueLai = Math.round(
          choVayEdit.ValueLai * choVayEdit.BocTrongVong,
        );
        choVayEdit.TienThuHangKy =
          ((tienVay + choVayEdit.ValueLai) * countTypePaid) / bocTrongVong;
        console.log("choVayEdit.TienThuHangKy1", choVayEdit.TienThuHangKy);
      }
    }
  }
  console.log("[TraGop IsDuNoGiamDan] setConfig after", {
    ChoVayId: choVayEdit.ChoVayId,
    Code: choVayEdit.Code,
    IsDuNoGiamDan: choVayEdit.IsDuNoGiamDan,
    StatusPaidHo: choVayEdit.StatusPaidHo,
    TypeDuNo: choVayEdit.TypeDuNo,
  });
  return {
    ...state,
    choVayEdit,
    postTraGopLoading: false,
    ConfigTMTG: action.payload,
  };
};
const showFormTraGop = (state, action) => {
  let choVay = {
    NgayVay: new Date(),
    CustomerId: 0,
    StatusPaidHo: 1,
    TypeDuNo: 1,
    TypePaid: 1,
    LaiTraGop: 0,
  };
  if (action.payload && action.payload.ChoVayId) {
    console.log("[TraGop IsDuNoGiamDan] showForm reducer payload", {
      ChoVayId: action.payload.ChoVayId,
      Code: action.payload.Code,
      IsDuNoGiamDan: action.payload.IsDuNoGiamDan,
      isDuNoGiamDan: action.payload.isDuNoGiamDan,
      DuNoGiamDan: action.payload.DuNoGiamDan,
      StatusPaidHo: action.payload.StatusPaidHo,
      TypeDuNo: action.payload.TypeDuNo,
      typeDuNo: action.payload.typeDuNo,
    });
    choVay = action.payload;
  }

  choVay.IsEditChoVay = true;
  choVay.IsEditCustomer = true;
  choVay.ChiPhiVay = choVay.ChiPhiVay
    ? parseFloat(choVay.ChiPhiVay.toFixed(2))
    : 0;
  console.log("[TraGop IsDuNoGiamDan] showForm reducer result", {
    ChoVayId: choVay.ChoVayId,
    Code: choVay.Code,
    IsDuNoGiamDan: choVay.IsDuNoGiamDan,
    StatusPaidHo: choVay.StatusPaidHo,
    TypeDuNo: choVay.TypeDuNo,
  });
  return {
    ...state,
    choVayEdit: choVay,
    isShowFormTraGop: !state.isShowFormTraGop,
  };
};
const getConfigSysTMTG = (state, action) => ({
  ...state,
});

const postTraGop = (state, action) => ({
  ...state,
  postTraGopLoading: true,
  postTraGopReturn: false,
  dataPost: action.dataPost,
});

const postTraGopSuccess = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.ChoVayId = action.payload.ChoVayId;
  choVayEdit.Code = action.payload.Code;
  choVayEdit.showButtonIn = true;
  choVayEdit.ThuChiId = action.payload.ThuChiId;
  choVayEdit.ImgDinhKemSave = action.payload.ImgDinhKem;
  choVayEdit.lstImgTaiSanSave = action.payload.lstImgTaiSan;
  choVayEdit.ImgCusNewSave = action.payload.ImgKhachHang;

  if (parseFloat(choVayEdit.BeforeAfter) === 2 && action.payload.ThuChiId > 0) {
    choVayEdit.showButtonInPhieuThu = true;
  }
  return {
    ...state,
    postTraGopLoading: false,
    postTraGopReturn: true,
    choVayEdit,
  };
};

const postTraGopFailed = (state, action) => ({
  ...state,
  postTraGopLoading: false,
});
const checkEditChoVay = (state, action) => ({
  ...state,
});
const setEnableEditChoVay = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.IsEditChoVay = action.payload.IsEditChoVay;
  choVayEdit.IsEditCustomer = action.payload.IsEditCustomer;
  return {
    ...state,
    choVayEdit,
  };
};
const checkEditCustomer = (state, action) => ({
  ...state,
});
const setEnableEditCustomer = (state, action) => {
  let choVayEdit = state.choVayEdit;
  choVayEdit.IsEditCustomer = action.payload.IsEditCustomer;
  return {
    ...state,
    choVayEdit,
  };
};
const getTaiSanTheoChoVayTMTG = (state, action) => ({
  ...state,
});
const themMoiTraGopReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TRA_GOP_EDIT:
      return setChoVayEdit(state, action);
    case SET_CONFIG_TM_TRA_GOP:
      return setConfig(state, action);
    case SHOW_FORM_TRA_GOP:
      return showFormTraGop(state, action);
    case GET_CONFIG_SYS_TMTG:
      return getConfigSysTMTG(state, action);
    case POST_TRA_GOP:
      return postTraGop(state, action);
    case POST_TRA_GOP_SUCCESS:
      return postTraGopSuccess(state, action);
    case POST_TRA_GOP_FAILURE:
      return postTraGopFailed(state, action);
    case CHECK_EDIT_TRA_GOP:
      return checkEditChoVay(state, action);
    case SET_ENABLE_EDIT_TRA_GOP:
      return setEnableEditChoVay(state, action);
    case CHECK_EDIT_CUSTOMER_TG:
      return checkEditCustomer(state, action);
    case SET_ENABLE_EDIT_CUSTOMER_TG:
      return setEnableEditCustomer(state, action);
    case SET_TAI_SAN_TG:
      return setTaiSanTraGop(state, action);
    case GET_TAI_SAN_THEO_CHO_VAY_TMTG:
      return getTaiSanTheoChoVayTMTG(state, action);
    default:
      return state;
  }
};
export default themMoiTraGopReducer;
